import {useEffect, useRef} from 'react';

export const useMemoizedFunction = <UpdatableFunction>(
  func: UpdatableFunction,
) => {
  const funcMemoized = useRef<typeof func>(func);

  useEffect(() => {
    funcMemoized.current = func;
  }, [funcMemoized, func]);

  return funcMemoized;
};
